import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
    FieldWrappers,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading
} from "../Styles/InputStyle2";
import { Select, MenuItem } from "@mui/material";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import * as Yup from "yup";


const BasicDetails = ({ onClose, stepOneData, setSelectedForm, setFormData }) => {
    const initialValues = {
        quantity: "",
        assetType: "",
        assetSubType: "",
        description: "",
    };
    const validationSchema = Yup.object({
        assetType: Yup.string().required("Asset type is required"),
        quantity: Yup.number()
            .required("Quantity is required")
            .max(200, "Units should be less than 200"),
        assetSubType: Yup.string().required("Asset sub-type is required"),
    });

    const handleSubmit = (values) => {

        const payload = {
            assetType: values.assetType,
            assetSubType: values.assetSubType,
            quantity: Number(values.quantity),
            description: values.description,
        }
        setFormData((prevFormData) => ({
            ...prevFormData,
            basicDetails: values,
        }));
        
        setSelectedForm("2");
    };
   
    const assetOptions = {
        "Furniture & Fixtures": [
            "Sofa",
            "Dining Table",
            "Chairs",
            "Bed & Mattress",
            "Wardrobe",
            "Coffee Table",
            "Study Table",
            "Bookshelf",
            "Shoe Rack",
            "Curtains & Blinds"
        ],
        "Electrical & Appliances": [
            "Air Conditioner (AC)",
            "Refrigerator",
            "Microwave Oven",
            "Washing Machine",
            "Ceiling Fan",
            "Geyser/Water Heater",
            "Water Purifier",
            "Induction Stove/Electric Stove",
            "LED/LCD TV",
            "Home Inverter & Battery",
            "CCTV Camera"
        ],
        "Plumbing & Sanitary": [
            "Water Pump",
            "Overhead Water Tank",
            "Sink & Faucet",
            "Toilet & Flush System",
            "Water Heater/Geyser",
            "Shower Set",
            "Drainage Pipes"
        ],
        "Security & Access Control": [
            "Door Locks & Smart Locks",
            "CCTV System",
            "Biometric Access System",
            "Intercom System",
            "Fire Alarm & Smoke Detectors",
            "Security Lights"
        ],
        "HVAC (Heating, Ventilation & Air Conditioning)": [
            "Centralized AC Unit",
            "Exhaust Fans",
            "Ventilation Ducts",
            "Air Purifier"
        ],
        "Outdoor & Common Area Assets": [
            "Garden Furniture",
            "Streetlights",
            "Parking Barriers",
            "Solar Panels",
            "Generator/Power Backup"
        ],
        "IT & Networking Equipment": [
            "WiFi Router",
            "Network Switch",
            "Server System",
            "Landline Phone"
        ],
        "Kitchen Equipment & Accessories": [
            "Gas Stove & Cylinder",
            "Chimney & Exhaust Fan",
            "Water Filter",
            "Dish Washer",
            "Kitchen Cabinets"
        ],
        "Miscellaneous Assets": [
            "Fire Extinguishers",
            "Elevators & Escalators",
            "Storage Racks",
            "Bulletin Boards & Notice Boards",
            "Signage & Nameplates"
        ]
    };


    return (
        <Formik initialValues={stepOneData || initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ values, setFieldValue, errors, touched }) => (
                <Form>
                    <ModalSubHeading>Step 1</ModalSubHeading>
                    <ModalHeading>Basic Details</ModalHeading>
                    <ScrollableContent>
                        <Wrapper>
                            <InputGroup>
                                <Label>Asset Type *</Label>
                                <Select
                                    value={values.assetType}
                                    onChange={(e) => {
                                        setFieldValue("assetType", e.target.value);
                                    }}
                                    displayEmpty
                                    fullWidth
                                    className="px-2"

                                >
                                    <MenuItem value="" disabled>
                                        Select Asset Type
                                    </MenuItem>
                                    {Object.keys(assetOptions).map((type) => (
                                        <MenuItem key={type} value={type}>
                                            {type}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {touched.assetType && errors.assetType && (
                                    <ErrorText>{errors.assetType}</ErrorText>
                                )}
                            </InputGroup>

                            {values.assetType && (
                                <InputGroup>
                                    <Label>Select {values.assetType} Type *</Label>
                                    <Select
                                        value={values.assetSubType}
                                        onChange={(e) => setFieldValue("assetSubType", e.target.value)}
                                        displayEmpty
                                        fullWidth
                                        className="px-2"

                                    >
                                        <MenuItem value="" disabled>
                                            Select {values.assetType} Option
                                        </MenuItem>
                                        {assetOptions[values.assetType].map((option) => (
                                            <MenuItem key={option} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {touched.assetSubType && errors.assetSubType && (
                                        <ErrorText>{errors.assetSubType}</ErrorText>
                                    )}
                                </InputGroup>
                            )}

                            <InputGroup>
                                <Label htmlFor="quantity">Total Units *</Label>
                                <FieldWrappers>
                                    <Field
                                        type="text"
                                        id="quantity"
                                        name="quantity"
                                        value={values.quantity}
                                        autoComplete="off"

                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        maxLength={10}
                                    />
                                </FieldWrappers>
                                {touched.quantity && errors.quantity && (
                                    <ErrorText>{errors.quantity}</ErrorText>
                                )}
                            </InputGroup>
                            <InputGroup>
                                <Label htmlFor="description">Description </Label>

                                <Field
                                    as={Textarea}
                                    id="description"
                                    name="description"
                                    rows={5}
                                    placeholder="Enter Description (e.g., Serial Number or Product Specifications)"
                                />

                            </InputGroup>
                        </Wrapper>
                    </ScrollableContent>
                    <ActionSection>
                        <SideCancelBtn type="button" onClick={onClose}>
                            Cancel
                        </SideCancelBtn>
                        <SubmitBtn type="submit">
                            Next
                        </SubmitBtn>
                    </ActionSection>
                </Form>
            )}
        </Formik>
    );
};


const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`;
const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const InputGroup = tw.div`w-full flex flex-col mt-2 md:mt-0`;
const Label = tw.label`text-sm text-gray-500 font-normal mb-1.5`;


export default BasicDetails;